import { Link } from "react-router";
import { useUserProvider } from "./provider";
import { Box, Text } from "@chakra-ui/react";
import "./index.css";
import { RiVerifiedBadgeFill } from "react-icons/ri";
/**
 *
 * @param {import("@chakra-ui/react").BoxProps} props
 * @returns
 */
const VerifiedBadge = (props) => {
  const user = useUserProvider();
  return (
    <Box color="green.400" {...props}>
      {user.isEmailVerified && <RiVerifiedBadgeFill />}
    </Box>
  );
};

export default VerifiedBadge;
